import { render, staticRenderFns } from "./MenuLink.vue?vue&type=template&id=97b7d9ce&"
import script from "./MenuLink.vue?vue&type=script&lang=js&"
export * from "./MenuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports